var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1330,
    height: 1252,
    viewBox: "0 0 1330 1252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1330 1252V0H0C87.985 52.6615 357.364 391.716 214.693 739.315C20.397 1212.69 1128.37 1243.45 1330 1252Z",
    fill: "url(#paint0_radial_737_10056)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_737_10056",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(419.436 576.654) rotate(90) scale(576.654 419.436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#DCFF7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47FF70"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp3);
export default __webpack_public_path__ + "static/media/signUp3.9c253d3f87f20a4432d5ce8342612e88.svg";
export { ForwardRef as ReactComponent };